<!-- 任务点排名 -->
<template>
  <div ref="wholePage">

    <a-card size="small">
      <template slot="title">
        <span style="margin-right: 4px">工单解决时长</span>
        <span slot="content">
          <a-form-model>
            <a-form-model-item>
              <a-checkable-tag :checked="selectedTeams.length === 0" @change="getAll()">全部</a-checkable-tag>
              <template v-for="team in teams">
                <a-checkable-tag :key="team.id" :checked="selectedTeams.indexOf(team.id) > -1" @change="checked => handleChange(team.id, checked)">
                  {{ team.name }}
                </a-checkable-tag>
              </template>
            </a-form-model-item>
          </a-form-model>
        </span>
      </template>
      <div id="ticket-solve-time" :style="{ height: height, width: width }" />

    </a-card>
    <a-card size="small">
      <template slot="title">
        <span style="margin-right: 4px">工单解决时长团队</span>
      </template>
      <div id="ticket-team-solve-time" :style="{ height: height, width: width }" />
    </a-card>
    <div v-if="data">
      <ticket-solve-list-modal ref="ticketListModal" :task-list="ticketList" />
    </div>
  </div>
</template>
<script>
import { ticketSolveTime, ticketSolveTimeTeam } from '@/api/data/ticket';
import { teamList } from '@/api/system/team';
import TicketSolveListModal from '@/pages/data/ticket/components/TicketSolveListModal';
export default {
  components: { TicketSolveListModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '360px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: false,
      chartId: 'ticket-solve-time',
      myChart: null,
      selectedTeams: [],
      teams: [],
      data: {},
      ticketList: [],
      ticketAll: [],
      ticketTeamAll: [],
      titleDict: {},
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: [
          {
            type: 'value',
            name: '工单解决时长',
            // min: 0,
            // max: 250,
            // interval: 50,
            axisLabel: {
              formatter: '{value} 小时'
            }
          },
          {
            type: 'value',
            name: '工单数量',
            // min: 0,
            // max: 25,
            // interval: 5,
            axisLabel: {
              formatter: '{value} 条'
            }
          }
        ],
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            startValue: 0,
            endValue: 14
          }
        ]
      },
      teamOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: [
          {
            type: 'value',
            name: '工单解决时长',
            // min: 0,
            // max: 250,
            // interval: 50,
            axisLabel: {
              formatter: '{value} 小时'
            }
          },
          {
            type: 'value',
            name: '工单数量',
            // min: 0,
            // max: 25,
            // interval: 5,
            axisLabel: {
              formatter: '{value} 条'
            }
          }
        ],
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            startValue: 0,
            endValue: 14
          }
        ]
      },
      xAxisData: [],
      series: []
    };
  },
  watch: {
    filterForm() {
      this.getData();
      this.getTeamData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.myChart.resize();
        });
      }, 200);
    }
  },
  created() {
    this.getTeamList();
    this.$emit('change', this.checkedDate, this.selectedTeams);
  },

  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    this.myChart = echarts.init(document.getElementById('ticket-solve-time'));
    this.myChart.getZr().on('click', param => {
      const pointInPixel = [param.offsetX, param.offsetY];
      // 判断给定的点是否在指定的坐标系或者系列上
      if (this.myChart.containPixel('grid', pointInPixel)) {
        // 获取到点击的 x轴 下标  转换为逻辑坐标
        const index = this.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
        this.onDetail(index, this.ticketAll);
      }
    });
    this.myTeamChart = echarts.init(document.getElementById('ticket-team-solve-time'));
    this.myTeamChart.getZr().on('click', param => {
      const pointInPixel = [param.offsetX, param.offsetY];
      // 判断给定的点是否在指定的坐标系或者系列上
      if (this.myChart.containPixel('grid', pointInPixel)) {
        // 获取到点击的 x轴 下标  转换为逻辑坐标
        const index = this.myTeamChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
        this.onDetail(index, this.ticketTeamAll);
      }
    });
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    drawTeamChart() {
      this.myTeamChart.setOption(this.teamOption, true);
      this.$nextTick(() => {
        this.myTeamChart.resize();
      });
    },
    handleChange(team_id, checked) {
      const { selectedTeams } = this;
      const nextSelectedTeams = checked ? [...selectedTeams, team_id] : selectedTeams.filter(t => t !== team_id);
      this.selectedTeams = nextSelectedTeams;
      this.getData();
    },
    getAll() {
      this.selectedTeams = [];
      this.getData();
    },
    getData() {
      this.loading = true;
      // console.log(this.filterForm);
      const req = {
        begin_date: this.filterForm.begin_date,
        end_date: this.filterForm.end_date,
        teams: this.selectedTeams
      };
      // console.log(req);
      ticketSolveTime(req)
        .then(res => {
          const x_axis = [];
          const spend_time = [];
          const count = [];
          const task_count_series = [];
          this.ticketAll = [];
          for (const key in res.data) {
            const user = res.data[key];
            x_axis.push(res.data[key].userName);
            this.ticketAll.push(res.data[key]);
            spend_time.push((res.data[key].spendTime / (res.data[key].sourceId.length * 3600)).toFixed(2));
            count.push(res.data[key].sourceId.length);
          }
          // 假设返回的数据格式为
          this.option.xAxis.data = x_axis;
          this.option.series = [{
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            name: '工单解决时长',
            data: spend_time
          }, {
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            yAxisIndex: 1,
            name: '工单数量',
            data: count
          }];
          this.loading = false;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getTeamData() {
      this.loading = true;
      // console.log(this.filterForm);
      const req = {
        begin_date: this.filterForm.begin_date,
        end_date: this.filterForm.end_date
      };
      // console.log(req);
      ticketSolveTimeTeam(req)
        .then(res => {
          const x_axis = [];
          const spend_time = [];
          const count = [];
          const task_count_series = [];
          this.ticketTeamAll = [];
          for (const key in res.data) {
            x_axis.push(res.data[key].teamName);
            this.ticketTeamAll.push(res.data[key]);
            spend_time.push((res.data[key].value / 3600).toFixed(2));
            count.push(res.data[key].sourceId.length);
          }
          // 假设返回的数据格式为
          this.teamOption.xAxis.data = x_axis;
          this.teamOption.series = [{
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            name: '工单解决时长',
            data: spend_time
          }, {
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            yAxisIndex: 1,
            name: '工单数量',
            data: count
          }];
          this.loading = false;
          this.drawTeamChart();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onDetail(index, tickets) {
      this.ticketList = tickets[index].sourceId;
      this.$refs.ticketListModal.open();
    },
    close() {
      this.detailVisible = false;
    },
    // 获取团队列表
    getTeamList() {
      teamList({ category: 1 }).then(res => {
        this.teams = res.data.items;
      });
    }
  }
};
</script>
    <style lang="less" scoped>
        .customer-card {
          margin-bottom: 10px;
        }
  </style>

